<template>
  <div>
    <v-menu
      v-if="desc.desc !== 'Admin'"
      class="mx-2"
      offset-y
      max-width="345"
      nudge-top="-3"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          outlined
          single-line
          hide-details
          placeholder="Search IO Number or Code"
          prepend-inner-icon="search"
          class="py-0 dashSearch"
          v-model="search"
          @keyup.enter="getIO"
          v-on="on"
        ></v-text-field>
      </template>
      <!-- <v-menu offset-y v-model="onSearch" max-width="236"> -->
      <VuePerfectScrollbar
        class="drawer-menu--scroll-filter-io"
        :settings="scrollSettings"
        v-if="listIO.length !== 0"
      >
        <v-list>
          <v-list-item
            v-for="(item, index) in listIO"
            :key="index"
            @click="toPage(item)"
          >
            <v-list-item-title>
              <h3
                v-if="item.group === 'io'"
                class="fs-12 primary--text text-decoration-underline"
              >
                Spending Report
              </h3>
              <h3
                v-else-if="item.group === 'approval'"
                class="fs-12 primary--text text-decoration-underline"
              >
                Spending Approval
              </h3>
              <h3
                v-else-if="item.group === 'po'"
                class="fs-12 primary--text text-decoration-underline"
              >
                PO Report
              </h3>
              <h3
                v-else-if="item.group === 'non_po'"
                class="fs-12 primary--text text-decoration-underline"
              >
                Non-PO Report
              </h3>
              <span class="fs-12" :title="item.desc"
                >{{ item.io_number }} - {{ item.nav_code }} -
                {{ item.desc }}</span
              >
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </VuePerfectScrollbar>
    </v-menu>
  </div>
</template>

<script>
import Swal from 'sweetalert2';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  components: {
    VuePerfectScrollbar
  },
  data: () => ({
    desc: JSON.parse(localStorage.getItem('userProfile')),
    search: '',
    onSearch: false,
    listIO: [],
    timeout: null,
    scrollSettings: {
      maxScrollbarLength: 160
    }
  }),
  watch: {
    search(val) {
      if (val === '') {
        this.listIO = [];
      } else {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if (val !== '') {
            this.getIO();
          }
        }, 1000);
      }
    }
  },
  methods: {
    getIO() {
      this.listIO = [];
      if (this.search !== '') {
        this.$emit('isLoading', true);
        let params = {
          key: this.search
        };
        this.$store
          .dispatch('dashboard/searchIO', params)
          .then(data => {
            console.log('search', data.data);
            this.$emit('isLoading', false);
            if (data.code === 200) {
              this.onSearch = true;
              if (data.data.length === 0) {
                this.listIO = [
                  {
                    group: '',
                    io_number: this.search,
                    desc: 'IO Number or Code not found'
                  }
                ];
              } else {
                this.listIO = data.data;
              }
            } else {
              Swal.fire('Failed!', data.response.data.data.error, 'error');
            }
          })
          .catch(err => {
            this.$emit('isLoading', false);
            Swal.fire('Failed!', err.response.data.data.text_en, 'error');
          });
      }
    },
    toPage(item) {
      switch (item.group) {
        case 'io':
          this.$router.push({
            name: 'searchSpending',
            params: {
              yearIo: item.year,
              io:
                item.io_number === '(Empty IO Number)'
                  ? item.nav_code
                  : item.io_number,
              boIo: item.budget_owner_id
            }
          });
          break;
        case 'approval':
          this.$router.push({
            name: 'searchApproval',
            params: {
              yearIo: item.year,
              io:
                item.io_number === '(Empty IO Number)'
                  ? item.nav_code
                  : item.io_number,
              boIo: item.budget_owner_id
            }
          });
          break;
        case 'po':
          this.$router.push({
            name: 'searchPO',
            params: {
              yearIo: item.year,
              io:
                item.io_number === '(Empty IO Number)'
                  ? item.nav_code
                  : item.io_number
            }
          });
          break;
        case 'non_po':
          this.$router.push({
            name: 'searchNonPO',
            params: {
              yearIo: item.year,
              io:
                item.io_number === '(Empty IO Number)'
                  ? item.nav_code
                  : item.io_number
            }
          });
          break;
      }
    }
  }
};
</script>

<style>
.drawer-menu--scroll-filter-io {
  max-height: 350px;
  overflow: auto;
}
</style>
